<template>
  <section class="table-content">
    <div class="notify-head">
      <div class="notify-title">
        <i class="el-icon-document-copy"></i>
        <span>通知公告</span>
      </div>
    </div>
    <div :style="{'height':blockHeight+'px'}" style="overflow: auto">
      <el-row class="notify-item" v-for="item in tableData" :key="item.id">
        <el-col :span="1">
          <div class="content-list-item-dot"></div>
        </el-col>
        <el-col :span="19">
          <div class="notify-content" @click="handleNotifyItemClick(item.id)">{{item.title}}</div>
        </el-col>
        <!--<el-col :span="5">-->
          <!--<div class="notify-org">-->
            <!--发布单位：{{item.organizationName}}-->
          <!--</div>-->
        <!--</el-col>-->
        <el-col :span="4">
          <div class="notify-time">
            [{{item.createTime.substring(0,10)}}]
          </div>
        </el-col>
      </el-row>
    </div>
    <el-pagination
      class="table-page"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total">
    </el-pagination>
  </section>
</template>
<script>
  import { portalNotify} from '@/api/restapi.js'
  export default {
    data () {
      return {
        blockHeight: (document.documentElement.clientHeight - 460),
        tableData: [],
        loading: false,
        pageInfo: {
          page: 1,
          total: 0,
          size: 10
        }
      }
    },
    mounted () {
      this.searchList()
    },
    methods: {
      searchList () {
        this.loading = true
        portalNotify(this.pageInfo.page,this.pageInfo.size).then(res => {
          this.loading = false
          if(res.data.code===0){
            this.tableData = res.data.data.list
            this.pageInfo.total = res.data.data.total
          }else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        }).catch(err => {
          this.loading = false
        })
      },
      handleNotifyItemClick (id) {
        this.$router.push('/portal/notifyDetail?id='+id)
      },
      handleSizeChange (val) {
        this.pageInfo.size = val
        this.searchList()
      },
      handleCurrentChange (val) {
        this.pageInfo.page = val
        this.searchList()
      }
    }
  }
</script>
<style>
  .table-content {
    background: #ffffff;
    width: 100%;
    padding: 10px 10px 15px;
  }
  .notify-head {
    width: 100%;
    border-bottom: 1px #0068BC solid;
  }
  .notify-head .notify-title{
    background: #0068BC;
    width: 120px;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    color: #FFFFFF;
    font-size: 16px;
  }
  .notify-item {
    border-bottom: 1px solid #CECECE;
    height: 40px;
    line-height: 40px;
    margin-left: 30px;
    margin-right: 30px;
  }
  .content-list-item-dot{
    height: 4px;
    width: 4px;
    margin-top: 18px;
    background: #07438A;
  }
  .notify-content {
    font-size: 13px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space:nowrap;
    cursor: pointer;
  }
  .notify-org {
    font-size: 13px;
    color: #ABABAB;
  }
  .notify-time {
    width: 100%;
    text-align: right;
    font-size: 10px;
    color: #ABABAB;
  }
  .table-content .table-page {
    margin-top: 10px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/portal/NotifyFile.vue